import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      vertical-align: ", ";\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        cursor: pointer;\n          &:hover {\n            background-color: ", ";\n          }\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      ", "\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      cursor: pointer;\n      &:hover {\n        background-color: ", ";\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      padding: 0px 8px;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      padding: 0px 4px;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      padding: 0px 4px;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  margin: 0;\n  padding: 0;\n  white-space: nowrap;\n  border-radius: 6px;\n  display: inline-flex;\n  vertical-align: middle;\n  \n  /* Sizes (default: m) */\n  ", "\n  font-weight: 600;\n  padding: 0px 6px;\n  ", "\n  ", "\n  ", "\n\n  /* Default */\n  background-color: ", ";\n  ", "\n    \n  \n  color: ", ";\n\n  ", ";\n\n  /* Soft */\n  ", "\n\n  /* Reverse */\n  ", "\n\n  /* Dark */\n  ", "\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from "react";
import styled, { css } from "styled-components";
import { text } from "../Utils/Constants";
var tags = ["span", "label"];
export var colors = {
  primary: ["branding", "primary"],
  secondary: ["branding", "secondary"],
  success: ["action", "success"],
  danger: ["action", "danger"],
  warning: ["action", "warning"],
  info: ["action", "info"],
  soft: ["action", "soft"],
  reverse: ["action", "reverse"],
  dark: ["action", "dark"]
};

var Label = function Label(props) {
  var _ref = colors[props.color] || [null, null],
      _ref2 = _slicedToArray(_ref, 2),
      group = _ref2[0],
      color = _ref2[1];

  return React.createElement(StyledLabel, _extends({}, props, {
    group: group,
    color: color
  }), props.children);
};

export var StyledLabel = styled.span(_templateObject(), function (props) {
  return text("text", props.size || "m");
}, function (props) {
  return props.size === "xs" && css(_templateObject2());
}, function (props) {
  return props.size === "s" && css(_templateObject3());
}, function (props) {
  return props.size === "l" && css(_templateObject4());
}, function (props) {
  return props.theme.color("branding", "primary");
}, function (props) {
  return props.as === "button" && css(_templateObject5(), function (props) {
    return props.theme.color("branding", "primary:hover");
  });
}, function (props) {
  return props.theme.color("text", "light");
}, function (props) {
  return props.color && css(_templateObject6(), props.theme.color(props.group, props.color), function (props) {
    return props.as === "button" && css(_templateObject7(), props.theme.color(props.group, "".concat(props.color, ":hover")));
  });
}, function (props) {
  return props.color === "soft" && css(_templateObject8(), props.theme.color("text", "primary"));
}, function (props) {
  return props.color === "reverse" && css(_templateObject9(), props.theme.color("text", "primary"));
}, function (props) {
  return props.color === "dark" && css(_templateObject10(), props.theme.color("text", "light"));
}, function (props) {
  return props.verticalAlign && css(_templateObject11(), props.verticalAlign);
});
export default Label;